import { render, staticRenderFns } from "./GeneralInventory.vue?vue&type=template&id=1197a160&scoped=true"
import script from "./GeneralInventory.vue?vue&type=script&lang=js"
export * from "./GeneralInventory.vue?vue&type=script&lang=js"
import style0 from "./GeneralInventory.vue?vue&type=style&index=0&id=1197a160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1197a160",
  null
  
)

export default component.exports